import {actionType} from './actionType';

export function setBusyStatus(busy) {
  return {
    type: actionType.ui.setBusyStatus,
    payload: busy
  }
}

export function setLanguage(lang) {
  return {
    type: actionType.ui.setLanguage,
    payload: lang
  }
}

export function pageLoginSetPin(pin) {
  return {
    type: actionType.ui.page.login.setPin,
    payload: pin
  }
}

export function pageLoginSetCurrentSlide(slide) {
  return {
    type: actionType.ui.page.login.setCurrentSlide,
    payload: slide
  }
}

export function pageLoginSelectCounterStaff(id) {
  return {
    type: actionType.ui.page.login.selectCounterStaff,
    payload: id
  }
}

export function pagePosScreenSetMode(mode) {
  return {
    type: actionType.ui.page.pos.posScreen.setMode,
    payload: mode
  }
}

export function pagePosScreenSetSupervisor(id) {
  return {
    type: actionType.ui.page.pos.customerInfo.setSupervisor,
    payload: id
  }
}

export function pagePosScreenSetSupervisorPin(pin) {
  return {
    type: actionType.ui.page.pos.customerInfo.setSupervisorPin,
    payload: pin
  }
}

export function pagePosScreenSetItemToRemove(id) {
  return {
    type: actionType.ui.page.pos.posScreen.setItemToRemove,
    payload: id
  }
}

export function pagePosScreenSetModifiedItems(items) {
  return {
    type: actionType.ui.page.pos.posScreen.setModifiedItems,
    payload: items
  }
}

export function pagePosScreenModifiedItemIncreaseQty(id) {
  return {
    type: actionType.ui.page.pos.posScreen.modifiedItemIncreaseQty,
    payload: id
  }
}

export function pagePosScreenModifiedItemDecreaseQty(id) {
  return {
    type: actionType.ui.page.pos.posScreen.modifiedItemDecreaseQty,
    payload: id
  }
}

export function pageCustomerSetCurrentSlide(slide) {
  return {
    type: actionType.ui.page.customer.setCurrentSlide,
    payload: slide
  }
}

export function pagePosMenuSetAllergenItem(item) {
  return {
    type: actionType.ui.page.pos.menu.setAllergenItem,
    payload: item
  }
}

export function pagePosQuickFuncSetSoldOutItems(items) {
  return {
    type: actionType.ui.page.pos.quickFunc.setSoldOutItems,
    payload: items
  }
}

export function pagePosQuickFuncSetSoldOutStatus(id, sold_out) {
  return {
    type: actionType.ui.page.pos.quickFunc.setSoldOutStatus,
    payload: {id, sold_out}
  }
}

export function pagePosKeypadSetSelectedMgtOrderPeriod(period) {
  return {
    type: actionType.ui.page.pos.keypad.setSelectedMgtOrderPeriod,
    payload: period
  }
}

export function pagePosKeypadSetSelectedOrderToVoid(id) {
  return {
    type: actionType.ui.page.pos.keypad.setSelectedOrderToVoid,
    payload: id
  }
}

export function pageTabletSetSelectedMealSet(mealSet) {
  return {
    type: actionType.ui.page.tablet.setSelectedMealSet,
    payload: mealSet
  }
}

export function pageVendingSetSelectedRetailBox(boxId) {
  return {
    type: actionType.ui.page.vending.setSelectedRetailBox,
    payload: boxId
  }
}

export function pageVendingSetSelectedRetailItem(itemId) {
  return {
    type: actionType.ui.page.vending.setSelectedRetailItem,
    payload: itemId
  }
}

